import { initSelect2, bindFilterEvents, restoreFromUrl } from "./filters.js";
// import { ContactForm } from './ContactForm.js';
// import { ReferralForm } from './ReferralForm.js';

var NearMe = {};

NearMe.init = function () {
  var wrapper = document.getElementById("ba-grid-wrapper");
  if (wrapper) {
    initSelect2();
    bindFilterEvents();
    restoreFromUrl();
  }

  NearMe.initSingle();
};

NearMe.initSingle = function () {
  // Swap header CTA on single BA pages.
  //
  // Sourced from "Contact Me". The card's "Schedule a Meeting" button used to feed this and was
  // removed 2026-09-01 (it duplicated Contact Me — same $schedule_url, same target). The header CTA
  // is DERIVED from the card, so deleting that button without repointing here would leave the guard
  // below silently no-opping and the header stuck on its default text and href.
  var scheduleLink = document.querySelector(".ba-profile-cta-contact");
  if (scheduleLink) {
    var cta = document.querySelector(".header-ds-cta");
    if (cta) {
      cta.href = scheduleLink.href;
      cta.textContent = "SCHEDULE A MEETING";
      cta.target = "_blank";
    }
  }

  // ContactForm.init();
  // ReferralForm.init();

  $(".forms-wrapper").on("click", "a.toggle-btn", function (event) {
    event.preventDefault();

    $(this)
      .closest(".forms-wrapper")
      .find(".forms")
      .attr("data-active", $(this).data("form"));

    $(this)
      .closest(".forms-wrapper")
      .find(".toggle-btns a")
      .removeClass("active");

    $(this).addClass("active");
  });
};

DOMReady(function () {
  NearMe.init();
});
